export default "__VITE_ASSET__BABlMP8S__"